import React, { useContext, createContext, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { onAuthStateChanged } from 'firebase/auth'

// eslint-disable-next-line import/no-cycle -- pre-existing store/api wiring cycle, same as api/errorLogger.js
import api from 'api'
import { auth } from 'providers/firebaseAuth'
import { store } from 'providers/store'

const AuthContext = createContext()

const AuthProvider = ({ children, extraContext = {} }) => {
  const [currentUser, setCurrentUser] = useState(null)
  const [isInitialized, setIsInitialized] = useState(false)
  const lastUid = useRef(null)

  useEffect(() => {
    const unregisterAuthObserver = onAuthStateChanged(auth, user => {
      // Cache only: LoginPersist is shared via localStorage, so clearing it would wipe the new tab's.
      if (user?.uid && lastUid.current && user.uid !== lastUid.current) {
        store.dispatch(api.util.resetApiState())
      }
      lastUid.current = user?.uid ?? null

      setCurrentUser(user)
      setIsInitialized(true)
    })

    return () => unregisterAuthObserver()
  }, [])

  return <AuthContext.Provider value={{ currentUser, isInitialized, ...extraContext }}>{children}</AuthContext.Provider>
}

AuthProvider.propTypes = {
  children: PropTypes.node,
  extraContext: PropTypes.object,
}

export default AuthProvider

export const useAuthValue = () => useContext(AuthContext)
